export interface StorageText {
  [key: string]: string;
}

export interface GroupedMouseoverText {
  [key: string]: string[];
}

export type ValueTextsStorage = Record<string, StorageText>;

export type GroupedTextsStorage = Record<string, GroupedMouseoverText>;

export enum MouseoverTextType {
  Configuration = 'configuration',
  DoorDesign = 'doorDesign',
  Grouped = 'groupedMouseovers'
}

export enum ValueTextType {
  ConfigurationPosDetails = 'ConfigurationPosDetails',
  ConfigurationPosDifferences = 'ConfigurationPosDifferences',
  CalculationSheet = 'CalculationSheet',
  Favorite = 'Favorite',
  PDFShort = 'PDFShort',
  PDFLong = 'PDFLong',
  Mouseover = 'Mouseover',
}

export interface ValueTextInput {
  id: string; // variable.id
  varName?: string;
  name?: string; // value.name
  text?: string | string[];
  value?: string | number | boolean | null; // value.value
  fullId: string;
  fullName: string;
  noPrintout?: boolean;
}

export interface ValueText extends ValueTextInput {
  text: string;
}
